import axios from "axios";
import { toast } from "react-toastify";
import HelperService from "./HelperService";

//Development
const BASE_URL = process.env.REACT_APP_BASE_URL;

interface PropData {
  action: string;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  isProductData?: boolean;
  id?: string;
  _file?: File;
  key?: string;
}

const WebService = {
  postAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      var bodyFormData = new FormData();
      if (props.isFormData) {
        for (let key in props.body) {
          let d = props.body[key];
          if (Array.isArray(d)) {
            d.forEach((el: any, i: any) => {
              if (props.isProductData) {
                bodyFormData.append(key + `[${i}][id]`, el.id);
                bodyFormData.append(key + `[${i}][type]`, el.type);
              } else {
                bodyFormData.append(key + `[${i}]`, el);
              }
            });
          } else {
            bodyFormData.append(key, d);
          }
        }
      }
      const headers = {
        "Content-Type": props.isFormData ? "multipart/form-data" : "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
        xapikey: localStorage.getItem("p_user_id"),
      };
      axios
        .post(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          {
            headers: headers,
          }
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  uploadAPI: function (props: PropData) {
    let formData = new FormData();
    if (props._file && props.key) {
      formData.append(props.key, props._file);
    }
    return new Promise((resolve, reject) => {
      for (let key in props.body) {
        formData.append(key, props.body[key]);
      }
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
      };
      axios
        .post(`${BASE_URL}${props.action}`, formData, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  putAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      var bodyFormData = new FormData();
      if (props.isFormData) {
        for (let key in props.body) {
          bodyFormData.append(key, props.body[key]);
        }
      }

      const headers = {
        "Content-Type": props.isFormData ? "multipart/form-data" : "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
        xapikey: localStorage.getItem("p_user_id"),
      };
      axios
        .put(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  getAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
      };
      axios
        .get(`${BASE_URL}${props.action}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  deleteAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
      };
      axios
        .delete(`${BASE_URL}${props.action}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  errorHandler: function (error: any) {
    if (error?.response) {
      error = error.response;
    }
    var errorMessage;
    if (!error || !error.status) {
      errorMessage = "Server Not Responding";
    } else if (error.status === 401) {
      errorMessage = "Unauthorized";
      this.logout();
    } else if (error.status === 500) {
      errorMessage =
        (error &&
          error.data &&
          error.data.ErrorDetails &&
          error.data.ErrorDetails.message) ||
        "An unkown exception has occur. Please Contact administrator";
    } else {
      errorMessage = error.data.message;
    }
    toast.error(errorMessage);
    return errorMessage;
  },

  addLoader(id?: any, status?: any) {
    if (id) {
      let button = document.getElementById(id) as HTMLButtonElement | null;
      if (button) {
        button.disabled = true;
        let loader = document.createElement("span");
        loader.innerHTML =
          '<span style="margin-right:5px" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span className="visually-hidden"></span>';
        button.prepend(loader);
      }
    }
  },

  removeLoader(id: any) {
    if (id) {
      let button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = false;
        button.removeChild(button.childNodes[0]);
      }
    }
  },

  logout() {
    localStorage.clear();
    window.location.href = "/login";
  },
};

export default WebService;
